import { Component, Input, OnInit } from '@angular/core';
import {faPencilAlt, faQuestionCircle, faCheckCircle, faExclamationCircle, faTimesCircle} from '@fortawesome/pro-light-svg-icons';
import { EditAuthorisedSignatoryComponent } from './../edit-authorised-signatory/edit-authorised-signatory.component';
import { CaseService } from '../../../shared/services/case.service';
import { DateTime } from 'luxon';
import { CreditSafeCheckComponent } from './../credit-safe-check/credit-safe-check.component';
import { ModalService } from 'src/app/shared/services/modal.service';

@Component({
  selector: 'app-info',
  templateUrl: './info.component.html',
  styleUrls: ['./info.component.scss']
})
export class InfoComponent implements OnInit {

  @Input() case: any;
  @Input() isMedium: boolean = false;
  @Input() isSmall: boolean = false;

  caseId: number;

  faPencilAlt = faPencilAlt;
  faQuestionCircle = faQuestionCircle;
  faCheckCircle = faCheckCircle;
  faExclamationCircle = faExclamationCircle;
  faTimesCircle = faTimesCircle;

  constructor(
            private caseService: CaseService,
            private modalService: ModalService) { }

  ngOnInit() {
    this.caseId = this.case.caseData.id;
  }

   ngOnChanges(): void {
    if (this.case) {
      this.caseId = this.case.caseData.id;
    }
  }


  editAuthorisedSignatory() {
  const modalRef = this.modalService.openWithOptions(EditAuthorisedSignatoryComponent, {});
  
  modalRef.componentInstance.caseId = this.case.caseData.id;
  modalRef.componentInstance.authorisedSignatoryUserId = this.case.caseData.authorisedSignatoryUserId;

  modalRef.result.then(
    (result) => {
      if (result === true) {
        this.caseService.refreshCase.next();
      }
    },
    () => {} // Dismiss callback
  );
}

  editCreditSafe(clientNo: number) {

    var client1City = this.isNullOrEmpty(this.case.caseData.partyOneAddressLine2) ? this.case.caseData.partyOneAddressLine3 : this.case.caseData.partyOneAddressLine2;
    var client2City = this.isNullOrEmpty(this.case.caseData.partyTwoAddressLine2) ? this.case.caseData.partyTwoAddressLine3 : this.case.caseData.partyTwoAddressLine2;

    let creditCheckData = {
        caseId: this.case.caseData.id,
        titleId: clientNo == 1 ? this.case.caseData.partyOneTitleId : this.case.caseData.partyTwoTitleId,
        firstName: clientNo == 1 ? this.case.caseData.partyOneFirstName : this.case.caseData.partyTwoFirstName,
        otherNames: clientNo == 1 ? this.case.caseData.partyOneMiddleNames : this.case.caseData.partyTwoMiddleNames,
        surname: clientNo == 1 ? this.case.caseData.partyOneLastName : this.case.caseData.partyTwoLastName,
        dateOfBirth: clientNo == 1 ? this.case.caseData.partyOneDateOfBirth : this.case.caseData.partyTwoDateOfBirth,
        buildingNo: clientNo == 1 ? this.getAddressBuildingNo(this.case.caseData.partyOneAddressLine1) : this.getAddressBuildingNo(this.case.caseData.partyTwoAddressLine1),
        buildingName: '',
        street: clientNo == 1 ? this.getAddressStreet(this.case.caseData.partyOneAddressLine1) : this.getAddressStreet(this.case.caseData.partyTwoAddressLine1),
        city: clientNo == 1 ? client1City : client2City,
        postCode: clientNo == 1 ? this.case.caseData.partyOnePostcode : this.case.caseData.partyTwoPostcode,
        clientNo: clientNo
    };

    const modalRef = this.modalService.openWithOptions(CreditSafeCheckComponent, {size: 'lg'});
  
    modalRef.componentInstance.initialCreditCheckData = creditCheckData;
    modalRef.componentInstance.caseId = this.case.caseData.id;
    modalRef.componentInstance.clientNo = clientNo;

    modalRef.result.then(
    (result) => {
      if (result === true) {
        this.caseService.refreshCase.next();
      }
    },
    () => {} // Dismiss callback
  );
   
  
  }

  formatDate(inDate: any){

    var formattedDate = '';


    if(inDate !== null)
    {

      var dt = DateTime.fromISO(inDate);

      formattedDate = dt.toFormat("dd-MM-yyyy");

    if(formattedDate == 'Invalid date' || formattedDate == 'Invalid DateTime')
      formattedDate = '';

    }


    return formattedDate;

  }
  private getAddressBuildingNo(address: string): any {
    if (address != null) {
      if (address.split(" ").length > 0) {
        var no = address.split(" ")[0].charAt(0);
       
        if (Number(no)) {
          return address.split(" ")[0];
        }
      } else {
        if (Number(address)) {
          return address;
        }
      }
     
    }

    return null;
  }
  private getAddressStreet(address: string): any {
    if (address != null) {
      if (address.split(" ").length > 0) {
        var row = address.split(" ");
        var no = row[0].charAt(0);

        if (Number(no)) {
          row.shift();
          return row.join(" ").trim();
        } else {
          return row.join(" ").trim();
        }
      } else {
        if (!Number(address)) {
          return address.trim();
        }
      }

    }

    return null;
  }

  private isNullOrEmpty(stringToCheck: string) {
    if (stringToCheck == null) return true;
    if (stringToCheck == "") return true;
    return false;
  }

  getCreditCheckIcon(status: string) {
  if (status == 'Success') return faCheckCircle;
  if (status == 'Error' || status == 'Fail') return faExclamationCircle;
  return faQuestionCircle;
}

  getCreditCheckClass(status: string) {
    if (status == 'Success') return 'check-success';
    if (status == 'Error' || status == 'Fail') return 'check-danger';
    return '';
  }

  yesNo(value: boolean | null): string {
  if (value == null) return '-';
  return value ? 'Yes' : 'No';
}
}
